import { Injectable, Pipe, PipeTransform, Signal } from "@angular/core";
import {
  EbuCarModelResponse,
  PackageResponse,
  PackageTagEnum,
  PropertyEnum,
  SelectedPackagesRequest,
  VehicleSearchResponse
} from "src/domain/client";
import { Store } from "@ngrx/store";
import {
  selectAdditionalPackages,
  selectBasePackages,
  selectCarInfo,
  selectSelectedEbuCar
} from "src/app/state/booking.selectors";

@Injectable({ providedIn: "root" })
@Pipe({
  name: "totalPrice",
  pure: false
})
export class TotalPricePipe implements PipeTransform {
  readonly basePackages: Signal<PackageResponse[] | null>;
  readonly additionalPackages?: Signal<PackageResponse[] | null>;
  readonly selectedEbuCar: Signal<EbuCarModelResponse | null>;
  readonly carInfo: Signal<VehicleSearchResponse | null>;

  constructor(private store: Store) {
    this.basePackages = this.store.selectSignal(selectBasePackages);
    this.additionalPackages = this.store.selectSignal(selectAdditionalPackages);
    this.selectedEbuCar = this.store.selectSignal(selectSelectedEbuCar);
    this.carInfo = this.store.selectSignal(selectCarInfo);
  }

  transform(allSelectedPackages: SelectedPackagesRequest[]): number {
    let total = 0;
    const allPackages =
      this.basePackages()?.concat(this.additionalPackages() ?? []) ?? [];
    for (const selectedPackage of allSelectedPackages || []) {
      const packageMatch = allPackages.find(
        (p) =>
          p.id ==
          (selectedPackage.packageId?.toString() ||
            selectedPackage.packageExternalId)
      );
      if (!packageMatch) continue;
      if (
        packageMatch.tags?.includes(PackageTagEnum.ServiceAgreement) &&
        this.carInfo()?.serviceAgreementResponse?.isSuccess
      )
        continue;

      if (packageMatch.properties?.includes(PropertyEnum.EuropcarDropoff)) {
        const selectedCar = this.selectedEbuCar();
        if (selectedCar) {
          total += Math.floor(selectedCar.previewValue);
        }
        continue;
      }

      total += packageMatch.price?.discounted ?? 0;
      for (const subpackage of packageMatch.subPackages || []) {
        if (subpackage.tags?.includes(PackageTagEnum.MainPackage)) {
          total += Math.floor(subpackage.price?.discounted ?? 0);
          continue;
        }
        if (selectedPackage.subPackageIds?.includes(subpackage.id)) {
          if (subpackage.properties?.includes(PropertyEnum.EuropcarDropoff)) {
            const selectedCar = this.selectedEbuCar();
            if (selectedCar) {
              total += Math.floor(selectedCar.previewValue);
            }
            continue;
          }
          total += Math.floor(subpackage.price?.discounted ?? 0);
          continue;
        }
      }
    }
    return total;
  }
}
